import React from 'react';
import Text from '../../ui/Text';
import Wrapper from '../../ui/Wrapper';
import OddsButton from '../../ui/Button';
import { detectMobile, formatDate } from 'utils/UiHelper';
import { isActiveBetButton } from '../../utils/UiHelper';
import { bindActionCreators } from 'redux';
import {
    addMarket as AddMarket,
    clearSingleMarket as ClearSingleMarket,
    clearSystemMarket as ClearSystemMarket,
} from '../../actions/BetslipActions';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { APP_PATH, goToWithBasePath } from '../../constants/appConfig';
import { browserHistory } from 'react-router';
import { trackEvents } from '../../helpers/VaixHelpers/VaixTracking';
import {
    VAIX_TRACKING_LOCATIONS,
    VAIX_TRACKING_TYPE,
} from '../../constants/vaix/VaixTrcakingConstants';
import { getErrorByCode } from '../../utils/Helper';

const EventsHighLights = ({
    market,
    betslip,
    addMarket,
    clearSingleMarket,
    clearSystemMarket,
    userId,
    position,
}) => {
    const getButtons = (market) => {
        return market.marketList[0]?.itemList.map((item, index) => {
            return (
                <OddsButton
                    width={
                        market.marketList[0]?.itemList.length > 1
                            ? `calc(100% / ${
                                  market.marketList[0]?.itemList.length
                              } - 3px)`
                            : '100%'
                    }
                    margin={'0'}
                    padding={'11px 5px'}
                    radius={'4px'}
                    align={'center'}
                    oddsYellow
                    active={isActiveBetButton(
                        item,
                        market.marketList[0],
                        betslip.setMarketsNew
                    )}
                    onClick={() => handleClick(item, market.marketList[0])}
                    key={`${index}_${item.competitor}_${item.odds}`}
                >
                    <Wrapper
                        flex
                        flexAlign={'center'}
                        justify={'space-between'}
                        margin={'0'}
                        padding={detectMobile ? '0 5px' : '0 5px'}
                        width={'100%'}
                    >
                        <Text
                            margin={'0 5px 0 0 !important'}
                            padding={'0'}
                            size={'13'}
                            lh={'13'}
                            align={'center'}
                            color={
                                isActiveBetButton(
                                    item,
                                    market.marketList[0],
                                    betslip.setMarketsNew
                                )
                                    ? '#333'
                                    : '#fff'
                            }
                            bold
                        >
                            {item.bet}
                        </Text>{' '}
                        <Text
                            margin={'0'}
                            padding={'0'}
                            size={'13'}
                            lh={'13'}
                            color={
                                isActiveBetButton(
                                    item,
                                    market.marketList[0],
                                    betslip.setMarketsNew
                                )
                                    ? '#333'
                                    : '#FDD804'
                            }
                            align={'center'}
                            bold
                        >
                            {item.odds.toFixed(2)}
                        </Text>
                    </Wrapper>
                </OddsButton>
            );
        });
    };

    const handleClick = (item, marketItem) => {
        if (isActiveBetButton(item, marketItem, betslip.setMarketsNew)) {
            if (betslip.betList.length > 1) {
                clearSystemMarket(marketItem.eventId, marketItem.marketId);
            } else {
                clearSingleMarket(marketItem.eventId, marketItem.marketId);
            }
        } else {
            if (betslip.customBetEventId === null) {
                trackEvents(
                    market,
                    VAIX_TRACKING_TYPE.clickOutcome,
                    VAIX_TRACKING_LOCATIONS.highlights,
                    '/sport/',
                    userId,
                    item.betNr,
                    position
                );
                addMarket(
                    marketItem.marketId,
                    item.betNr,
                    item.odds,
                    marketItem.live ? '1' : '0',
                    marketItem.sportId,
                    betslip.hasMarkets
                );
            } else {
                NotificationManager.error(getErrorByCode('BAD_COMBINATION'));
            }
        }
    };

    const getIcon = (id) => {
        return (
            <img
                src={`${APP_PATH}/img/sports/${id}.png`}
                alt=""
                className={'event-highlights-item__sport-icon'}
            />
        );
    };

    const handleRedirect = () => {
        trackEvents(
            market,
            VAIX_TRACKING_TYPE.clickEvent,
            VAIX_TRACKING_LOCATIONS.highlights,
            '/sport/',
            userId,
            0,
            position
        );

        browserHistory.push(goToWithBasePath(`/kamp/${market.eventId}`));
    };

    return (
        <Wrapper
            height={'100%'}
            width={detectMobile() ? '280px' : '100%'}
            padding={'0'}
            margin={'0'}
            display={'block'}
            boxSizing={'border-box'}
            color={'#1E1E1E'}
            borderRadius={'8px'}
            border={' 1px solid var(--Neutral-stroke_400, #DFE5ED)'}
            className={'event-highlights-item'}
            position={'relative'}
            overflow={'hidden'}
            zIndex={1}
        >
            <Wrapper
                height={'100%'}
                width={'100%'}
                padding={'16px 16px 61px'}
                margin={'0'}
                flex
                flexDirection={'row'}
                justify={'space-between'}
                boxSizing={'border-box'}
                className={'event-highlights-item__content-wrapper'}
                position={'relative'}
                zIndex={1}
                onClick={handleRedirect}
                bgColor={'#fff'}
            >
                {getIcon(market.sportId)}
                <Wrapper
                    height={'100%'}
                    width={'100%'}
                    padding={'0'}
                    margin={'0'}
                    flex
                    flexDirection={'row'}
                    justify={'space-between'}
                    boxSizing={'border-box'}
                    className={'event-highlights-item__content'}
                >
                    <div
                        className={'event-highlights-item__description-wrapper'}
                    >
                        <div className={'bage-text three-dots'}>
                            <span>{`${market.competition}`}</span>
                        </div>
                        <Text
                            margin={'8px 0 0!important'}
                            padding={'0 5px 0 0'}
                            size={detectMobile() ? '14' : '13'}
                            lh={'21'}
                            bold
                            color={'#1E1E1E'}
                            className={'three-dots'}
                        >
                            {market.homeTeam}
                        </Text>
                        <Text
                            margin={'0'}
                            padding={'0 5px 0 0'}
                            size={detectMobile() ? '14' : '13'}
                            lh={'21'}
                            bold
                            color={'#1E1E1E'}
                            className={'three-dots'}
                        >
                            {market.awayTeam}
                        </Text>
                    </div>
                    <div className={'event-highlights-item__date-wrapper'}>
                        <Text
                            margin={'0'}
                            padding={'0'}
                            size={'10'}
                            lh={'10'}
                            align={'right'}
                            color={'#1E1E1E'}
                            capitalize
                            flex={'0'}
                        >
                            {formatDate(market.kickoff, 'ddd, DD. MMM')}{' '}
                        </Text>
                        <Text
                            margin={'12px 0 0!important'}
                            padding={'0'}
                            size={'14'}
                            lh={'14'}
                            flex={'0'}
                            bold
                            align={'right'}
                            color={'#1E1E1E'}
                        >
                            {formatDate(market.kickoff, 'HH:mm')}
                        </Text>
                    </div>
                </Wrapper>
            </Wrapper>
            <div className="event-highlights-item__buttons-wrapper">
                {getButtons(market)}
            </div>
        </Wrapper>
    );
};

const mapStateToProps = (state) => {
    return { betslip: state.betslip };
};

const mapDispatchToProps = (dispatch) => {
    return {
        addMarket: bindActionCreators(AddMarket, dispatch),
        clearSingleMarket: bindActionCreators(ClearSingleMarket, dispatch),
        clearSystemMarket: bindActionCreators(ClearSystemMarket, dispatch),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EventsHighLights);
